/* eslint-disable */
export default {
  Inbound: 'Recebida',
  Outbound: 'Efetuada',
  log: 'Registo',
  save: 'Guardar e nova',
  discard: 'Rejeitar e nova',
  hangup: 'Desligar',
  reject: 'Para correio de voz',
  saveDraftAndCreateNewLog: 'Guardar rascunho e criar novo registo de chamadas',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
